'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hierarchiseDimensionWithNativeHierarchy = undefined;

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var hierarchiseDimensionWithNativeHierarchy = exports.hierarchiseDimensionWithNativeHierarchy = function hierarchiseDimensionWithNativeHierarchy(dimension) {
  var values = R.sortBy(R.prop('__indexPosition'), dimension.values || []);
  var indexed = R.indexBy(R.prop('id'), values);
  var grouped = R.groupBy(function (val) {
    return val.parent && R.has(val.parent, indexed) ? val.parent : '#ROOT';
  }, values);

  var index = -1;
  var getChildren = function getChildren(_ref) {
    var parentsIndexes = _ref.parentsIndexes,
        parentId = _ref.parentId;

    var childs = R.propOr([], parentId, grouped);
    return R.reduce(function (acc, child) {
      index = index + 1;
      var refined = R.pipe(R.assoc('__indexPosition', index), R.assoc('parents', parentsIndexes), R.assoc('parent', R.isEmpty(parentsIndexes) ? undefined : parentId))(child);
      var children = getChildren({ parentsIndexes: R.append(index, parentsIndexes), parentId: child.id });
      return R.concat(acc, R.prepend(refined, children));
    }, [], childs);
  };

  return R.set(R.lensProp('values'), getChildren({ parentsIndexes: [], parentId: '#ROOT' }))(dimension);
};